export const SPANISH_TRANSLATIONS = {
  text: {
    book_a_reservation: 'Hacer Una Reservación',
    date_of_visit: 'Fecha de Visita',
    required: 'Requerido',
    daily_max: 'Exede límite diario',
    min_date: 'Reservaciónes mismo dia o futuro',
    max_date: 'Fecha muy lejana',
    blackout_date: 'Fecha no es disponible',
    disabled_date: 'Seleccione una fecha diferente',
    location: 'Lugar',
    locations: 'Lugares',
    select_location: 'Seleccionar un Lugar',
    location_not_allowed: 'Lugar no permitida',
    too_far_from_location: 'Lugar muy lejana',
    entrance: 'Entrada',
    select_entrance: 'Selecciona la Entrada',
    entrance_not_allowed: 'Entrada no permitida',
    select_location_first: 'Escoge Lugar Primero',
    timeslot: 'Hora de reservación',
    select_timeslot: 'Escoge Hora de Reservación',
    timeslot_not_allowed: 'Hora de reservación no es permitida',
    group_size: 'Tamańo del Groupo',
    select_group_size: 'Escoge el Tamańo del Grupo',
    group_size_not_allowed: 'No se permite el tamaño del grupo',
    name: 'Nombre',
    name_length: 'Tiene que ser 2 a 64 caracteres',
    email: 'Correo electrónico',
    email_valid: 'Entra un correo electrónico válido',
    phone: 'Teléfono',
    phone_number: 'Número de teléfono',
    phone_number_valid: 'Entra un número de teléfono valido',
    notes_valid: 'Tiene que ser 1 a 2048 caracteres',
    agree: 'Yo soy de acuerdo',
    agree_full: 'Yo exepto el completo',
    and: 'y',
    terms_and_conditions: 'términos y condiciones',
    book_reservation: 'Completar reservación',
    continue: 'Continuar',
    back: 'Regresar',
    manage_reservations: 'Administrar Reservación',
    upcoming_reservations: 'Proxima Reservación',
    reservation_details: 'Detalles de la Reservación',
    access: 'Acceso',
    thank_you: 'Gracias por tu reservación',
    qr_sent: 'Un enlace para un codigo QR asido enviado a tu',
    present_qr: 'Por favor presenta tu codigo QR quando llegas.',
    important_notes: 'Notas Importantes',
    arrive_by: 'Por favor llegan en la lugar por',
    use_the: 'Por favor usan el',
    leave_location_by: 'Tienes que ir de la lugar por ',
    new_reservation: 'Nueva Reservación',
    location_check_in: 'Lugar Registro',
    you_are_checked_in: 'Estás registrado en la ubicación',
    check_out: 'Revisa de la Lugar',
    reservation: 'Reservación',
    modify_reservation: 'Modificar Reservación',
    cancel_reservation: 'Cancelar Reservación',
    time: 'Tiempo',
    time_remaining: 'Tiempo Restante',
    expiration_date: 'Fecha de Caducidad',
    student_name: 'Student Name',
    number_of_people: '# de Personase',
    at_the_location: 'en el lugar',
    view_reservation: 'Ver Reservación',
    notes: 'Notas',
    select_date_first: 'Seleccione la Fecha Primero',
    are_you_sure: 'Estas seguro',
    are_you_sure_cancel: 'Estás seguro de queries cancelar tu reservación?',
    close: 'Cerca',
    reservation_error: 'Encontramos un error',
    reservation_create_error_message:
      'Lo sientio, encontramos un error al intentar hacer su reservatión. Haga clic en el botón de abajo para volver a intentarlo.',
    reservation_cancel_error_message:
      'Lo sentimos, encontramos un error al intentar cancelar su reservación. Haga clic en el botón de abajo para volver a intentarlo.',
    try_again: 'Inténtalo de Nuevo',
    long_term_reservations: 'Reservación a Largo Plazo',
    main: 'Principal',
    add_to_calendar: 'AÑADIR AL CALENDARIO',
    reservation_at: 'Reservación en',
    all_day: 'Todo el Dia',
    enter_phone_number: 'Ingresa un número de teléfono',
    not_allowed: 'No Autorizada',
    not_allowed_message: 'No está autorizado a utilizar este enlace.',
    automatic_check_out: 'La Salida Automática',
    not_checked_in: 'Actualmente no está registrado en una ubicación. Escanee un código QR de ubicación a continuación para registrarse.',
    please_click_continue: 'Haga clic en el botón de abajo para ser redirigido y hacer una reserva pública.',
    please_contact_location: 'Comuníquese con la ubicación con la que está tratando de reservar si cree que este mensaje es un error.',
    location_check_in_error: 'Ubicación Desconocida',
    location_check_in_error_message: 'Ha escaneado una ubicación desconocida. Haga clic en el botón de abajo para volver a intentarlo.',
    location_check_out_error: 'Encontramos un error',
    location_check_out_error_message:
      'Lo sientio, encontramos un error al intentar finalizar la compra desde su ubicación. Haga clic en el botón de abajo para volver a intentarlo.',
    visit_type: 'Tipo de Visita',
    select_visit_type: 'Seleccionar Tipo de Visita',
    visit_type_not_allowed: 'Tipo de Visita no permitida',
  },
  html: {
    temperature_taken: '<strong>tomar mi temperatura</strong>',
    masks_required: 'uso <strong>cubrebocas personal</strong>',
  },
};
